import { createAction } from 'Helpers';
import couponTypes from './types';

const couponActions = {
	getCouponsRequest: createAction(couponTypes.GET_COUPON.REUQEST),
	getCouponsSuccess: createAction(couponTypes.GET_COUPON.SUCCESS),
	getCouponsFailure: createAction(couponTypes.GET_COUPON.FAILURE),
	clearCouponsFailure: createAction(couponTypes.GET_COUPON.CLEAR),

	getCouponsMobileRequest: createAction(couponTypes.GET_COUPON_MOBILE.REUQEST),
	getCouponsMobileSuccess: createAction(couponTypes.GET_COUPON_MOBILE.SUCCESS),
	getCouponsMobileFailure: createAction(couponTypes.GET_COUPON_MOBILE.FAILURE),

	invalidateCouponsRequest: createAction(couponTypes.INVALIDATE_COUPON.REUQEST),
	invalidateCouponsSuccess: createAction(couponTypes.INVALIDATE_COUPON.SUCCESS),
	invalidateCouponsFailure: createAction(couponTypes.INVALIDATE_COUPON.FAILURE),
};

export default couponActions;
